import FormattedMessage from 'I18n/components/FormattedMessage';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { objectTypes } from '../../constants/types';
import EditHOC from '../../hoc/EditHOC';
import { generateObjectDirectLink } from '../../utils/urls';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ObjectCardButtons({
  item,
  type,
  setRemoveCandidateObject,
  openObjectDirectLink,
  portalId,
  readonly,
  appName
}) {
  const link = generateObjectDirectLink(portalId, type, item.id);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(ButtonGroup, {
      children: [type !== objectTypes.meetings ? /*#__PURE__*/_jsx(IconButton, {
        size: "xs",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationList.openInHubspot"
        }),
        use: "tertiary",
        onClick: e => openObjectDirectLink(e, link, type),
        children: /*#__PURE__*/_jsx(ExternalLinkIcon, {
          size: "300"
        })
      }) : null, /*#__PURE__*/_jsx(EditHOC, {
        isPastMeeting: readonly,
        children: /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": `${appName}-associations-remove-button-${type}`,
          size: "xs",
          use: "tertiary",
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "associationList.remove"
          }),
          onClick: () => {
            setRemoveCandidateObject({
              item,
              type
            });
          },
          children: /*#__PURE__*/_jsx(DeleteIcon, {})
        })
      })]
    })
  });
}
export default ObjectCardButtons;